import * as React from "react";

const History = () => {
  return (
    <ol className="references">
      <li>
        Centers for Disease Control and Prevention. MMWR Weekly:{" "}
        <em>pneumocystis</em> pneumonia—Los Angeles.{" "}
        <em>MMWR Morb Mortal Wkly Rep.</em> 1981;30(21):1-3. Accessed July 30,
        2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.cdc.gov/mmwr/preview/mmwrhtml/june_5.htm"
        >
          https://www.cdc.gov/mmwr/preview/mmwrhtml/june_5.htm
        </a>
      </li>
      <li>
        Fauci AS, Lane HC. Four decades of HIV/AIDS—much accomplished, much to
        do. <em>N Engl J Med.</em> 2020;383(1):1-4.
      </li>
      <li>
        Davis J; Kaiser Family Foundation.{" "}
        <em>
          Evolution of an Epidemic: 25 Years of HIV/AIDS Media Campaigns in the
          U.S.
        </em>{" "}
        June 2006. Accessed July 30, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.kff.org/wp-content/uploads/2013/01/7515.pdf"
        >
          https://www.kff.org/wp-content/uploads/2013/01/7515.pdf
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Understanding AIDS brochure.
        1988; HHS Publication No. (CDC) HHS-88-8404. Accessed July 30, 2021.
        <br className="d-block d-md-none" />{" "}
        <a target="_blank" href="https://stacks.cdc.gov/view/cdc/6927">
          https://stacks.cdc.gov/view/cdc/6927
        </a>
      </li>
      <li>
        Curran JW, Jaffe HW; Centers for Disease Control and Prevention (CDC).
        AIDS: the early years and CDC’s response. <em>MMWR Suppl.</em>{" "}
        <span className="d-inline-block">2011;60(4):64-69.</span>
      </li>
      <li>
        AIDS.gov. A Timeline of HIV/AIDS. Accessed July 22, 2021.&nbsp;
        <b className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.hiv.gov/sites/default/files/aidsgov-timeline.pdf"
        >
          https://www.hiv.gov/sites/default/files/aidsgov-timeline.pdf
        </a>
      </li>
      <li>
        HIV.gov. Preventing mother-to-child transmission of HIV. Last updated
        February 26, 2021. Accessed July 22, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.hiv.gov/hiv-basics/hiv-prevention/reducing-mother-to-child-risk/preventing-mother-to-child-transmission-of-hiv"
        >
          https://www.hiv.gov/hiv-basics/hiv-prevention/reducing-mother-to-child-risk/preventing-mother-to-child-transmission-of-hiv
        </a>
      </li>
      <li>
        Tseng A, Seet J, Phillips EJ. The evolution of three decades of
        antiretroviral therapy: challenges, triumphs and the promise of the
        future. <em>Br J Clin Pharmacol.</em> 2015;79(2):182-194.
      </li>
      <li>
        Huang YA, Zhu W, Smith DK, Harris N, Hoover KW. HIV preexposure
        prophylaxis, by race and ethnicity—United States, 2014&ndash;2016.{" "}
        <em>MMWR Morb Mortal Wkly Rep.</em> 2018;67(41):1147-1150.
      </li>
      <li>
        Centers for Disease Control and Prevention. Condom distribution
        programs. Reviewed May 27, 2021. Accessed July 29, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/effective-interventions/prevent/condom-distribution-programs/index.html"
        >
          https://www.cdc.gov/hiv/effective-interventions/prevent/condom-distribution-programs/index.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Injection drug use. Reviewed
        December 8, 2020. Accessed July 29, 2021.
        <br />
        <a target="_blank" href="https://www.cdc.gov/hiv/risk/drugs/index.html">
          https://www.cdc.gov/hiv/risk/drugs/index.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and gay and bisexual
        men. Reviewed September 16, 2020. Accessed July 30, 2021.
        <br />
        <a target="_blank" href="https://www.cdc.gov/hiv/group/msm/index.html">
          https://www.cdc.gov/hiv/group/msm/index.html
        </a>
      </li>
      <li>
        Avert. Myths about HIV and AIDS. Updated February 24, 2021. Accessed
        July 31, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.avert.org/hiv-transmission-prevention/myths"
        >
          https://www.avert.org/hiv-transmission-prevention/myths
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. The AIDS epidemic in the
        United States, 1981-early 1990s. Reviewed March 26, 2021. Accessed July
        26, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.cdc.gov/museum/online/story-of-cdc/aids/index.html"
        >
          https://www.cdc.gov/museum/online/story-of-cdc/aids/index.html
        </a>
      </li>
      <li>
        Health Resources & Services Administration Ryan White HIV/AIDS Program.
        Who was Ryan White? Reviewed October 2016. Accessed July 22, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://hab.hrsa.gov/about-ryan-white-hivaids-program/who-was-ryan-white"
        >
          https://hab.hrsa.gov/about-ryan-white-hivaids-program/who-was-ryan-white
        </a>
      </li>
      <li>
        Hamel L, Firth J, Hoff T, Kates J, Levine S, Dawson L. HIV/AIDS in the
        lives of gay and bisexual men in the United States. Published September
        25, 2014. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.kff.org/hivaids/report/hivaids-in-the-lives-of-gay-and-bisexual-men-in-the-united-states/"
        >
          https://www.kff.org/hivaids/report/hivaids-in-the-lives-of-gay-and-bisexual-men-in-the-united-states/
        </a>
      </li>
      <li>
        Mahajan AP, Sayles JN, Patel VA, et al. Stigma in the HIV/AIDS epidemic:
        a review of the literature and recommendations for the way forward.{" "}
        <em>AIDS.</em> 2008;22(Suppl 2):S67-S79.
      </li>
      <li>
        Advisory Committee of the People with AIDS. The Denver Principles
        (1983). 2007. Accessed July 26, 2021.
        <br />
        <a
          target="_blank"
          href="https://data.unaids.org/pub/externaldocument/2007/gipa1983denverprinciples_en.pdf"
        >
          https://data.unaids.org/pub/externaldocument/2007/gipa1983denverprinciples_en.pdf
        </a>
      </li>
      <li>
        Gay Men’s Health Crisis (GMHC). History. Accessed July 22, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a target="_blank" href="https://www.gmhc.org/history/">
          https://www.gmhc.org/history/
        </a>
      </li>
      <li>
        Gay Men’s Health Crisis (GMHC). Workforce development. Accessed July 22,
        2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.gmhc.org/services/workforce-development/"
        >
          https://www.gmhc.org/services/workforce-development/
        </a>
      </li>
      <li>
        National Minority AIDS Council (NMAC). Programs. Accessed July 22,
        2021.&nbsp;
        <br className="d-block d-md-none" />
        <a target="_blank" href="https://www.nmac.org/programs/">
          https://www.nmac.org/programs/
        </a>
      </li>
      <li>
        AIDS Coalition To Unleash Power (ACT UP). Our mission. Accessed July 22,
        2021.&nbsp;
        <br className="d-block d-md-none" />
        <a target="_blank" href="https://actupny.com/contact/">
          https://actupny.com/contact/
        </a>
      </li>
      <li>
        Latino Commission on AIDS. Mission statement. Accessed July 22,
        2021.&nbsp;
        <br className="d-block d-md-none" />
        <a target="_blank" href="https://www.latinoaids.org/about/about.php">
          https://www.latinoaids.org/about/about.php
        </a>
      </li>
      <li>
        Black AIDS Institute. Who we are. Accessed July 22, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a target="_blank" href="https://blackaids.org/who-we-are/">
          https://blackaids.org/who-we-are/
        </a>
      </li>
      <li>
        The White House. Presidential Advisory Council on HIV/AIDS. Executive
        Order 12963, FR Doc 95-14983. <em>Federal Register.</em> 1995;60(116).
        Accessed July 26, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.govinfo.gov/content/pkg/FR-1995-06-16/pdf/95-14983.pdf"
        >
          https://www.govinfo.gov/content/pkg/FR-1995-06-16/pdf/95-14983.pdf
        </a>
      </li>
      <li>
        Secretary of Health and Human Services. Charter—Presidential Advisory
        Council on HIV/AIDS. January 15, 2020. Accessed July 26, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://hivgov-prod-v3.s3.amazonaws.com/s3fs-public/pacha-charter-2020.pdf"
        >
          https://hivgov-prod-v3.s3.amazonaws.com/s3fs-public/pacha-charter-2020.pdf
        </a>
      </li>
      <li>
        The White House Office of National AIDS Policy. National HIV/AIDS
        Strategy for the United States. July 13, 2010. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://hivgov-prod-v3.s3.amazonaws.com/s3fs-public/nhas.pdf"
        >
          https://hivgov-prod-v3.s3.amazonaws.com/s3fs-public/nhas.pdf
        </a>
      </li>
      <li>
        National Institute of Allergy and Infectious Diseases. HIV/AIDS.
        Reviewed June 29, 2020. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.niaid.nih.gov/diseases-conditions/hivaids"
        >
          https://www.niaid.nih.gov/diseases-conditions/hivaids
        </a>
      </li>
      <li>
        National Institute of Allergy and Infectious Diseases. HIV cure.
        Reviewed March 26, 2019. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.niaid.nih.gov/diseases-conditions/hiv-cure-research"
        >
          https://www.niaid.nih.gov/diseases-conditions/hiv-cure-research
        </a>
      </li>
    </ol>
  );
};

export default History;
